import { OnInit, AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, Renderer2, ViewChild, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScrollStateService } from '../../services/scroll-state.service';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule, TranslateModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, AfterViewInit, AfterViewChecked {
  isDarkMode = false;
  delayedDarkMode = false;
  isHomePage = false;
  private navbarUpdated = false;
  isThemeAnimating = false;

  @ViewChild('logo', { static: false }) logoRef!: ElementRef
  @ViewChild('toggleIcon') toggleIconRef!: ElementRef;
  @ViewChild('header', { read: ElementRef }) headerEl?: ElementRef<HTMLElement>;

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private renderer: Renderer2,
    private translate: TranslateService,
    public scroll: ScrollStateService) {
    // Setze Initialsprache
    this.translate.use('de');
  }

  ngOnInit(): void {


    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
        this.updateNavbar(triggeredByToggle);
      });
    });

    console.log('ThemeService in NavBarComponent', this.themeService.id);
  }


  ngAfterViewInit(): void {


    this.router.events.subscribe(() => {
      this.isHomePage = this.router.url === '/' || this.router.url === '/home';
    });

    // this.updateNavbarHeight();
  }

  ngAfterViewChecked(): void {
    if (this.logoRef && this.toggleIconRef && !this.navbarUpdated) {

      this.navbarUpdated = true;
      // this.updateNavbar(triggeredByToggle);
      Promise.resolve().then(() => {


        const triggeredByToggle = this.themeService.wasThemeToggled();
        this.updateNavbar(triggeredByToggle);
      });
    }
  }

  getHeaderElement(): HTMLElement | null {
    return this.headerEl?.nativeElement ?? null;
  }

  private updateNavbar(triggeredByToggle: boolean): void {

    if (!this.logoRef || !this.toggleIconRef) {
      return
    }

    const logo = this.logoRef.nativeElement;
    const toggleIcon = this.toggleIconRef.nativeElement;

    if (!triggeredByToggle) {
      // 🔥 1️⃣ Beim Seiten-Refresh das Bild SOFORT setzen

      if (this.isDarkMode) {
        this.renderer.addClass(logo, 'darkMode-dark');
        this.renderer.removeClass(logo, 'darkMode-light');
        this.renderer.addClass(toggleIcon, 'darkMode-dark');
        this.renderer.removeClass(toggleIcon, 'darkMode-light');
      } else {
        this.renderer.addClass(logo, 'darkMode-light');
        this.renderer.removeClass(logo, 'darkMode-dark');
        this.renderer.addClass(toggleIcon, 'darkMode-light');
        this.renderer.removeClass(toggleIcon, 'darkMode-dark');
      }

    } else {
      // Beim Themewechsel verzögert umschalten
      // LOGO
      this.isThemeAnimating = true;
      setTimeout(() => {
        if (this.isDarkMode) {
          this.renderer.addClass(logo, 'darkMode-dark');
          this.renderer.removeClass(logo, 'darkMode-light');
        } else {
          this.renderer.addClass(logo, 'darkMode-light');
          this.renderer.removeClass(logo, 'darkMode-dark');
        }
      }, 500);

      // THEME BTN
      setTimeout(() => {
        if (this.isDarkMode) {
          this.renderer.addClass(toggleIcon, 'darkMode-dark');
          this.renderer.removeClass(toggleIcon, 'darkMode-light');
        } else {
          this.renderer.addClass(toggleIcon, 'darkMode-light');
          this.renderer.removeClass(toggleIcon, 'darkMode-dark');
        }


      }, 900);

      setTimeout(() => {
        this.isThemeAnimating = false;

      }, 2000);

    }
  }

  toggleTheme(): void {
    if (this.isThemeAnimating) {
      return;
    }
    this.themeService.toggleTheme();
  }

  switchLang(lang: 'de'|'en'|'de-CH') {
    this.translate.use(lang);
  }

  // private updateNavbarHeight(): void {
  //   if (!this.headerRef) return;


  //   const h = Math.round(
  //     this.headerRef.nativeElement.offsetHeight
  //   );

  //   console.log('[NavbarHeight]', h);
  // }
}
